import type { CustomerFormValues } from '@/api/types';
import { MySection } from '@/components/custom/my-section';
import { Grid, TextField } from '@mui/material';
import type { FieldErrors, UseFormRegister } from 'react-hook-form';

interface CustomerBasicInfoSectionProps {
  register: UseFormRegister<CustomerFormValues>;
  errors: FieldErrors<CustomerFormValues>;
}

export function CustomerBasicInfoSection({ register, errors }: CustomerBasicInfoSectionProps) {
  return (
    <MySection
      title="Customer details"
      description="Provide the essential information about the customer."
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Name"
            placeholder="e.g. Jane Doe"
            InputLabelProps={{ shrink: true }}
            {...register('name')}
            error={!!errors.name}
            helperText={errors.name?.message}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Phone number"
            placeholder="e.g. +66 1234 5678"
            InputLabelProps={{ shrink: true }}
            {...register('phone')}
            error={!!errors.phone}
            helperText={errors.phone?.message}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            multiline
            minRows={3}
            label="Address"
            placeholder="Shipping address"
            InputLabelProps={{ shrink: true }}
            {...register('address')}
            error={!!errors.address}
            helperText={errors.address?.message}
          />
        </Grid>
      </Grid>
    </MySection>
  );
}

export default CustomerBasicInfoSection;
